import http, { RequestConf } from '@/utils/http'

import {
  AddEndpointToMeshReq,
  AddUserSshPubKeyReq,
  BindTeamMemberReq,
  BuyEIPReq,
  CancelSnapshotReq,
  CreateACLL3RuleReq,
  CreateACLL4ExceptionRuleReq,
  CreateACLResourceReq,
  CreateAssetTransferReq,
  CreateCredentialReq,
  CreateDeploymentReq,
  CreateInstanceReq,
  CreateOrderReq,
  CreateSnapshotReq,
  CreateTeamMemberReq,
  CreateTeamReq,
  CredentialBindResourceReq,
  CredentialUnbindResourceReq,
  DeleteACLL3RuleReq,
  DeleteACLL4ExceptionRuleReq,
  DeleteACLResourceReq,
  DeleteCredentialReq,
  DeleteEIPReq,
  DeleteEndpointFromMeshReq,
  DeleteImageReq,
  DeleteInstanceReq,
  DeleteMeshReq,
  DeleteSnapshotReq,
  DeleteTeamMemberInstanceReq,
  DeleteTeamMemberResourceQuotasReq,
  DisableTotpReq,
  DistributeCreditReq,
  EduVerifyReq,
  EnableTotpReq,
  FrozenTeamMemberReq,
  GenerateImageUploadTokenReq,
  GetACLL3RulesReq,
  GetACLL4ExceptionRulesReq,
  GetACLResourceReq,
  GetAttachmentsReq,
  GetAvailableEIPsReq,
  GetBriefMonitorDataReq,
  GetCredentialListReq,
  GetCredentialReq,
  GetDeploymentListReq,
  GetDonateOrgsReq,
  GetGatewayListReq,
  GetImageListReq,
  GetInstanceListReq,
  GetItemsReq,
  GetMachineListReq,
  GetMachinePriceReq,
  GetMeshEndPointListReq as GetMeshEndpointListReq,
  GetMeshEndpointNodesReq as GetMeshEndpointCandidatesReq,
  GetMeshListReq,
  GetMonitorDataReq,
  GetNATListReq,
  GetOrdersReq,
  GetPrivateRegionAgentInstancesReq,
  GetPrivateRegionInfoReq,
  GetPrivateRegionLeasedTimeMetricsReq,
  GetPrivateRegionNodeHardwareBriefReq,
  GetPrivateRegionNodeHardwaresReq,
  GetPrivateRegionNodeModelsReq,
  GetPrivateRegionNodeSpecsReq,
  GetPrivateRegionStatsNodeListReq,
  GetPrivateRegionStatsOverviewReq,
  GetPrivateRegionVGpuSpecsReq,
  GetScaleMetricListReq,
  GetScaleSpecListReq,
  GetScaleSpecReq,
  GetSnapListReq,
  GetTeamInfoReq,
  GetTeamListReq,
  GetTeamMemberInstancesReq,
  GetTeamMemberListReq,
  GetTeamMemberReq,
  GetTeamMemberResourceACLReq,
  GetTeamMemberSnapshotsReq,
  GetTeamMemberVolumeStatsReq,
  GetTeamResourceACLRangesReq,
  GetTeamResourceACLReq,
  GetTeamSharedSnapshotsReq,
  GetTeamStatMemberFSSpacesReq,
  GetTeamStatMemberInstancesReq,
  GetTeamStatMemberSnapshotsReq,
  GetTeamStatReq,
  ImportTeamSnapshotReq,
  ListAssetTransfersReq,
  LoginReq,
  Pagi,
  PatchOrderReq,
  PostGrantMonitorTokenReq,
  PurchaseItemReq,
  RegenerateRecoveryCodesReq,
  RegisterImageReq,
  ReMemberClaimCreditsReq,
  RemoveTeamMemberReq,
  RemoveTeamMemberSnapshotReq,
  RemoveTeamSharedSnapshotReq,
  RenewInstanceReq,
  ResumeImageReq,
  ResumeSnapshotReq,
  RotateCredentialReq,
  SwitchImageBillingReq,
  SwitchSnapshotBillingReq,
  TransferCreditsToTeamReq,
  UnbindTeamMemberReq,
  UnFrozenTeamMemberReq,
  UpdateACLL3RuleReq,
  UpdateACLL4ExceptionRuleReq,
  UpdateAttachmentsReq,
  UpdateCredentialReq,
  UpdateDeploymentReq,
  UpdateInstancePortReq,
  UpdateInvoiceTitleReq,
  UpdateMeshReq,
  UpdatePrivateRegionNodeStatusReq,
  UpdatePrivateRegionSpecsReq,
  UpdateTeamInfoReq,
  UpdateTeamMemberNickNameReq,
  UpdateTeamMemberNoteReq,
  UpdateTeamMemberPasswordReq,
  UpdateTeamMemberResourceACLReq,
  UpdateTeamMemberRoleReq,
  UpdateTeamOrderReq,
  UpdateTeamResourceACLReq,
  VerifyPrivateRegionSpecsReq,
} from './type-request'
import {
  BuyEIPRes,
  CreateACLL3RuleRes,
  CreateACLL4ExceptionRuleRes,
  CreateACLResourceRes,
  CreateAssetTransferRes,
  CreateCredentialRes,
  CreateOrderRes,
  CreateTeamMemberRes,
  CreateTeamRes,
  DistributeCreditRes,
  EnableTotpRes,
  GenerateImageUploadTokenRes,
  GetAccountRes,
  GetACLL3RulesRes,
  GetACLL4ExceptionRulesRes,
  GetACLResourceRes,
  GetAvailableEIPsRes,
  GetBriefMonitorDataRes,
  GetCredentialListRes,
  GetCredentialRes,
  GetDeploymentBillRes,
  GetDeploymentListRes,
  GetDomainListRes,
  GetDonateOrgsRes,
  GetExchangeRateRes,
  GetFollowTaskRes,
  GetGatewayListRes,
  GetImageListRes,
  GetInstanceBillsRes,
  GetInstanceListRes,
  GetInvoiceTitleRes,
  GetItemConsumeRes,
  GetItemsRes,
  GetMachineListRes,
  GetMachinePriceRes,
  GetMemberVolumesRes,
  GetMeshEndPointListRes as GetMeshEndpointListRes,
  GetMeshEndpointNodesRes as GetMeshEndpointCandidatesRes,
  GetMeshListRes,
  GetMonitorDataRes,
  GetNATListRes,
  GetPrivateRegionAgentInstancesRes,
  GetPrivateRegionInfoRes,
  GetPrivateRegionLeasedTimeMetricsRes,
  GetPrivateRegionNodeHardwareBriefRes,
  GetPrivateRegionNodeHardwaresRes,
  GetPrivateRegionNodeModelsRes,
  GetPrivateRegionNodeSpecsRes,
  GetPrivateRegionPermissionRes,
  GetPrivateRegionStatsNodesListRes,
  GetPrivateRegionStatsOverviewRes,
  GetPrivateRegionVGpuSpecsRes,
  GetScaleMetricListRes,
  GetScaleSpecListRes,
  GetScaleSpecRes,
  GetSnapListRes,
  GetTeamInfoRes,
  GetTeamListRes,
  GetTeamMemberBillsRes,
  GetTeamMemberInstancesRes,
  GetTeamMemberListRes,
  GetTeamMemberRes,
  GetTeamMemberResourceACLRes,
  GetTeamMemberSnapshotsRes,
  GetTeamMemberVolumeStatsRes,
  GetTeamResourceACLRangesRes,
  GetTeamResourceACLRes,
  GetTeamSharedSnapshotsRes,
  GetTeamStatFSSpacesRes,
  GetTeamStatInstancesRes,
  GetTeamStatMemberFSSpacesRes,
  GetTeamStatMemberInstancesRes,
  GetTeamStatMemberSnapshotsRes,
  GetTeamStatMembersRes,
  GetTeamStatOverviewRes,
  GetTeamStatPersonalInstancesRes,
  GetTeamStatSharedSnapshotsRes,
  GetTeamStatSnapshotsRes,
  GetTeamStatStoragesRes,
  GetTotpStatusRes,
  GetUserSshPubKeyRes,
  GetVolumesRes,
  ListAssetDomainsRes,
  ListAssetTransfersRes,
  LoginRes,
  PostGrantMonitorTokenRes,
  PurchaseItemRes,
  RegenerateRecoveryCodesRes,
  RegisterImageRes,
  RotateCredentialRes,
  SetupTotpRes,
  TransferCreditsToTeamRes,
  UpdateACLL3RuleRes,
  UpdateACLL4ExceptionRuleRes,
  UpdatePrivateRegionNodeStatusRes,
  UpdatePrivateRegionSpecsRes,
  UpdateTeamMemberPasswordRes,
  VerifyPrivateRegionSpecsRes,
} from './type-response'
import { ServerAttachmentInfo, ServerBillInfo, ServerUserInfo } from './type-server'

export function get<R = any, D = any>(path: TemplateStringsArray) {
  return (data?: D, config: RequestConf = {}) => http.get<R>(path[0], { ...config, params: data })
}

export function post<R = any, D = any>(path: TemplateStringsArray) {
  return (data?: D, config: RequestConf = {}) => http.post<R>(path[0], data, config)
}

export function put<R = any, D = any>(path: TemplateStringsArray) {
  return (data?: D, config: RequestConf = {}) => http.put<R>(path[0], data, config)
}

export function del<R = any, D = any>(path: TemplateStringsArray) {
  return (data?: D, config: RequestConf = {}) =>
    http.delete<R>(path[0], { ...config, params: data })
}

export function patch<R = any, D = any>(path: TemplateStringsArray) {
  return (data?: D, config: RequestConf = {}) => http.patch<R>(path[0], data, config)
}

export const API = {
  checkPrivilege: get<{ allowed: boolean }, { type: number }>`/privilege`,
  login: post<LoginRes, LoginReq>`/login`,
  getTotpStatus: get<GetTotpStatusRes>`/mfa/totp`,
  setupTotp: post<SetupTotpRes>`/mfa/totp/setup`,
  enableTotp: post<EnableTotpRes, EnableTotpReq>`/mfa/totp/enable`,
  disableTotp: post<any, DisableTotpReq>`/mfa/totp/disable`,
  regenerateRecoveryCodes: post<
    RegenerateRecoveryCodesRes,
    RegenerateRecoveryCodesReq
  >`/mfa/totp/recovery-codes`,
  getUserInfo: get<ServerUserInfo>`/user`,
  getAccount: get<GetAccountRes>`/user/account`,
  getDomainList: get<GetDomainListRes>`/domain/list`,
  updatePassword: post<
    any,
    { name: string; ori_password: string; password: string }
  >`/reset_password`,

  getMachineList: get<GetMachineListRes, GetMachineListReq>`/machines`,
  getMachinePrice: get<GetMachinePriceRes, GetMachinePriceReq>`/machine/price`,
  getImageList: get<GetImageListRes, GetImageListReq>`/images`,
  getSnapList: get<GetSnapListRes, GetSnapListReq>`/snapshots`,
  getMeshList: get<GetMeshListRes, GetMeshListReq>`/meshes`,
  getMeshEndpointList: get<GetMeshEndpointListRes, GetMeshEndpointListReq>`/mesh/endpoints`,
  getNodeList: get<GetInstanceListRes, GetInstanceListReq>`/instances`,
  getNodeBill: get<GetInstanceBillsRes, { request_id: string }>`/instance/bill`,
  getTeamMemberInstanceBills: get<
    GetInstanceBillsRes,
    { res_id: string; inst_res_id: string }
  >`/team/member/instance/bills`,
  getUserBills: get`/user/bills`,
  getGatewayList: get<GetGatewayListRes, GetGatewayListReq>`/gateway/list`,
  getDeploymentList: get<GetDeploymentListRes, GetDeploymentListReq>`/deployment/list`,

  payment: post<
    { url?: string; paymentCode?: string; clientSecret?: string },
    { fee: number; type: number; return_url?: string }
  >`/payment`,
  capture: post<{ code: string }>`/payment/paypal/capture`,

  getOrders: get<any, GetOrdersReq>`/orders`,
  getItems: get<GetItemsRes, GetItemsReq>`/items`,
  purchaseStoragePlan: post<
    any,
    { item_id: number; modify?: boolean; auto_renewal?: boolean }
  >`/order`,
  updateOrderAutoRenewal: patch<
    any,
    { auto_renewal: boolean; catalog: number; type: number }
  >`/order`,
  updateOrder: patch<Record<string, never>, PatchOrderReq>`/order`,
  purchaseInstanceSubscription: post<PurchaseItemRes, PurchaseItemReq>`/order`,

  getVolumes: get<GetVolumesRes>`/subvolumes`,
  modifySubvolume: patch<any, { id: number; quota_gb: number }>`/subvolume`,
  createSubvolume: post<any, { type: number; domain: any; init_quota_gb: number }>`/subvolume`,

  registerByOauth: post<
    { token?: string },
    { oauth_type: string; oauth_code: string; password: string }
  >`/user`,
  loginByOauth: post<
    { token: string },
    {
      oauth_type: string
      oauth_code: string
      oauth_redirect_uri?: string
      inviter_code?: string
      register_channel?: import('@/consts/registerChannel').RegisterChannel
    }
  >`/login`,

  // instances
  createInstance: post<any, CreateInstanceReq>`/instance`,
  deleteInstance: del<any, DeleteInstanceReq>`/instance`,
  renewInstance: patch<Record<string, never>, RenewInstanceReq>`/instance`,
  createSnapshot: patch<any, CreateSnapshotReq>`/instance`,
  getBriefMonitorData: get<GetBriefMonitorDataRes, GetBriefMonitorDataReq>`/mon/node`,
  getDetailMonitorData: get<GetMonitorDataRes, GetMonitorDataReq>`/mon`,

  grantNodeMetricsAccess: post<PostGrantMonitorTokenRes, PostGrantMonitorTokenReq>`/auth/grant`,

  _getBriefMonitorDataWithToken: async (params: GetBriefMonitorDataReq, bearer: string) => {
    const res = await http.get<GetBriefMonitorDataRes>('/mon/node', {
      params,
      headers: { Authorization: `Bearer ${bearer}` },
    })
    return res
  },
  _getDetailMonitorDataWithToken: async (
    params: GetMonitorDataReq,
    bearer: string,
    config: RequestConf = {},
  ) => {
    const res = await http.get<GetMonitorDataRes>('/mon', {
      ...config,
      params,
      headers: {
        ...config.headers,
        Authorization: bearer.startsWith('Bearer ') ? bearer : `Bearer ${bearer}`,
      },
    })
    return res
  },

  updateInstancePort: post<any, UpdateInstancePortReq>`/node_op`,

  getAttachments: get<ServerAttachmentInfo, GetAttachmentsReq>`/attachments`,
  updateAttachments: put<any, UpdateAttachmentsReq>`/attachments`,

  // auto deployment
  createDeployment: post<any, CreateDeploymentReq>`/deployment`,
  updateDeployment: put<any, UpdateDeploymentReq>`/deployment`,
  deleteDeployment: del<any, { res_id: string }>`/deployment`,
  getDeploymentBill: get<GetDeploymentBillRes, Pagi<{ res_id: string }>>`/deployment/bill`,

  // auto scaling
  createScalingSpec: post<any, any>`/scale_spec`,
  getScaleSpecList: get<GetScaleSpecListRes, GetScaleSpecListReq>`/scale_spec/list`,
  getScaleSpec: get<GetScaleSpecRes, GetScaleSpecReq>`/scale_spec`,
  updateScaleSpecRule: put<any, any>`/scale_spec/rule`,
  updateScaleReplicaLimit: put<any, any>`/scale_spec/replica_limit`,
  updateScaleRuntimes: put<any, any>`/scale_spec/runtimes`,
  updateScaleBehaviors: put<any, any>`/scale_spec/behaviors`,
  toggleScaleSpec: put<any, any>`/scale_spec/enabled`,
  deleteScaleSpec: del<any, any>`/scale_spec`,
  updateScaleMetrics: put<any, any>`/scale_spec/metrics`,
  getScaleMetricList: get<GetScaleMetricListRes, GetScaleMetricListReq>`/scale_metrics`,
  createScaleMetrics: post<any, any>`/scale_metrics`,

  // snapshot
  getItemConsume: get<GetItemConsumeRes, { type: number }>`/item_consume`,
  resumeSnapshot: patch<any, ResumeSnapshotReq>`/snapshot`,
  cancelSnapshot: patch<any, CancelSnapshotReq>`/snapshot`,
  switchSnapshotBilling: patch<any, SwitchSnapshotBillingReq>`/snapshot`,
  resumeImage: patch<any, ResumeImageReq>`/image`,
  switchImageBilling: patch<any, SwitchImageBillingReq>`/image`,
  deleteSnapshot: del<any, DeleteSnapshotReq>`/snapshot`,

  // label
  createLabel: post<any, { source_id: number; subject: string; type: number }>`/label`,
  modifyLabel: patch<any, { id: number; subject: string; type: number }>`/label`,
  deleteLabel: del<any, { id: number }>`/label`,

  // mesh clustering
  createMesh: post<
    any,
    { name: string; domain: number; cluster_type: number; network_type: number }
  >`/mesh`,
  deleteMesh: del<any, DeleteMeshReq>`/mesh`,
  updateMesh: patch<any, UpdateMeshReq>`/mesh`,
  addEndpointToMesh: post<any, AddEndpointToMeshReq>`/mesh/endpoint`,
  deleteEndpointFromMesh: del<any, DeleteEndpointFromMeshReq>`/mesh/endpoint`,
  getMeshEndpointCandidates: get<
    GetMeshEndpointCandidatesRes,
    GetMeshEndpointCandidatesReq
  >`/mesh/endpoint/candidates`,

  // profile
  callbackXFollow: post<Record<string, never>, Record<string, string>>`/user/callback/x/follow`,
  getFollowTask: get<GetFollowTaskRes, { platform: number }>`/user/follow_task`,
  getEduVerifyStatus: get`/edu_verify`,
  eduVerify: post<any, EduVerifyReq>`/edu_verify`,
  // user ssh pubkey
  getUserSshPubKey: get<GetUserSshPubKeyRes, any>`/user/public_key`,
  addUserSshPubKey: post<any, AddUserSshPubKeyReq>`/user/public_key`,
  deleteUserSshPubKey: del<any, any>`/user/public_key`,

  // exchange rate
  getExchangeRate: get<
    GetExchangeRateRes,
    { credit_cent: number; pay_currency: number }
  >`/payment/exchange_rate/lookup`,

  // NAT
  getNATList: get<GetNATListRes, GetNATListReq>`/nats`,
  checkNATPort: get<any, { res_id: string; listen_port: number }>`/nat/port_mapping/check`,

  // Elastic IP
  getAvailableEIPs: get<GetAvailableEIPsRes, GetAvailableEIPsReq>`/eips`,
  getEIPBill: get<{ bill: ServerBillInfo }, { res_id: string }>`/nat/bill`,
  buyEIP: post<BuyEIPRes, BuyEIPReq>`/nat`,
  deleteEIP: (data: DeleteEIPReq, config: RequestConf = {}) =>
    http.delete<any>('/nat', { ...config, data }),

  // ACL (Public IP)
  // L3 / L4 rule limits per Network/ACL Resource: 10 / 50
  getACLResource: get<GetACLResourceRes, GetACLResourceReq>`/acl/resource`,
  createACLResource: post<CreateACLResourceRes, CreateACLResourceReq>`/acl/resource`,
  deleteACLResource: (data: DeleteACLResourceReq, config: RequestConf = {}) =>
    http.delete<any>('/acl/resource', { ...config, data }),

  // ACL L3 Rule
  getACLL3Rules: get<GetACLL3RulesRes, GetACLL3RulesReq>`/acl/l3_rules`,
  createACLL3Rule: post<CreateACLL3RuleRes, CreateACLL3RuleReq>`/acl/l3_rule`,
  updateACLL3Rule: patch<UpdateACLL3RuleRes, UpdateACLL3RuleReq>`/acl/l3_rule`,
  deleteACLL3Rule: (data: DeleteACLL3RuleReq, config: RequestConf = {}) =>
    http.delete<any>('/acl/l3_rule', { ...config, data }),

  // ACL L4 Exception Rule
  getACLL4ExceptionRules: get<
    GetACLL4ExceptionRulesRes,
    GetACLL4ExceptionRulesReq
  >`/acl/l4_exception_rules`,
  createACLL4ExceptionRule: post<
    CreateACLL4ExceptionRuleRes,
    CreateACLL4ExceptionRuleReq
  >`/acl/l4_exception_rule`,
  updateACLL4ExceptionRule: patch<
    UpdateACLL4ExceptionRuleRes,
    UpdateACLL4ExceptionRuleReq
  >`/acl/l4_exception_rule`,
  deleteACLL4ExceptionRule: (data: DeleteACLL4ExceptionRuleReq, config: RequestConf = {}) =>
    http.delete<any>('/acl/l4_exception_rule', { ...config, data }),

  // donate organizations
  getDonateOrgs: get<GetDonateOrgsRes, GetDonateOrgsReq>`/invoice_title/ezpay/donate_orgs`,

  // invoice title
  getInvoiceTitle: get<GetInvoiceTitleRes>`/invoice_title`,
  updateInvoiceTitle: put<{ code: number; msg: string }, UpdateInvoiceTitleReq>`/invoice_title`,
  // Custom Image
  registerImage: post<RegisterImageRes, RegisterImageReq>`/image`,
  generateImageUploadToken: post<
    GenerateImageUploadTokenRes,
    GenerateImageUploadTokenReq
  >`/auth/grant`,
  deleteImage: (data: DeleteImageReq, config: RequestConf = {}) =>
    http.delete<any>('/image', { ...config, data }),

  // Private Region
  getPrivateRegionInfo: get<GetPrivateRegionInfoRes, GetPrivateRegionInfoReq>`/pregion/info`,
  getPrivateRegionLeasedTimeMetrics: get<
    GetPrivateRegionLeasedTimeMetricsRes,
    GetPrivateRegionLeasedTimeMetricsReq
  >`/pregion/metrics/leased`,
  getPrivateRegionModels: get<
    GetPrivateRegionNodeModelsRes,
    GetPrivateRegionNodeModelsReq
  >`/pregion/models`,
  getPrivateRegionNodeHardwareBrief: get<
    GetPrivateRegionNodeHardwareBriefRes,
    GetPrivateRegionNodeHardwareBriefReq
  >`/pregion/node/hardware_brief`,
  getPrivateRegionNodeHardwares: get<
    GetPrivateRegionNodeHardwaresRes,
    GetPrivateRegionNodeHardwaresReq
  >`/pregion/nodes/hardwares`,
  getPrivateRegionNodesList: get<
    GetPrivateRegionStatsNodesListRes,
    GetPrivateRegionStatsNodeListReq
  >`/pregion/nodes/list`,
  getPrivateRegionOverview: get<
    GetPrivateRegionStatsOverviewRes,
    GetPrivateRegionStatsOverviewReq
  >`/pregion/overview`,
  getPrivateRegionPermission: get<GetPrivateRegionPermissionRes>`/pregion/permission`,

  // Instance Spec APIs (Private Region)
  getPrivateRegionAgentInstances: get<
    GetPrivateRegionAgentInstancesRes,
    GetPrivateRegionAgentInstancesReq
  >`/pregion/instance/list`,
  updatePrivateRegionNodeStatus: post<
    UpdatePrivateRegionNodeStatusRes,
    UpdatePrivateRegionNodeStatusReq
  >`/pregion/node/status`,
  getPrivateRegionVGpuSpecs: get<
    GetPrivateRegionVGpuSpecsRes,
    GetPrivateRegionVGpuSpecsReq
  >`/pregion/spec/vgpuspec_list`,
  getPrivateRegionNodeSpecs: get<
    GetPrivateRegionNodeSpecsRes,
    GetPrivateRegionNodeSpecsReq
  >`/pregion/spec/list`,
  verifyPrivateRegionSpecs: post<
    VerifyPrivateRegionSpecsRes,
    VerifyPrivateRegionSpecsReq
  >`/pregion/spec/verify`,
  updatePrivateRegionSpecs: post<
    UpdatePrivateRegionSpecsRes,
    UpdatePrivateRegionSpecsReq
  >`/pregion/spec/update`,

  // Team
  createTeam: post<CreateTeamRes, CreateTeamReq>`/team`,
  createTeamOrder: post<CreateOrderRes, CreateOrderReq>`/order`,
  updateTeamOrder: post<CreateOrderRes, UpdateTeamOrderReq>`/order`,
  getTeamList: get<GetTeamListRes, GetTeamListReq>`/teams`,
  getTeamInfo: get<GetTeamInfoRes, GetTeamInfoReq>`/team`,
  updateTeamInfo: patch<Record<string, never>, UpdateTeamInfoReq>`/team/info`,

  // Team Resource ACL
  getTeamResourceACLRanges: get<
    GetTeamResourceACLRangesRes,
    GetTeamResourceACLRangesReq
  >`/team/resource_acl_ranges`,
  getTeamResourceACL: get<GetTeamResourceACLRes, GetTeamResourceACLReq>`/team/resource_acl`,
  getTeamMemberResourceACL: get<
    GetTeamMemberResourceACLRes,
    GetTeamMemberResourceACLReq
  >`/team/member/resource_acl`,
  updateTeamResourceACL: patch<any, UpdateTeamResourceACLReq>`/team/resource_acl`,
  updateTeamMemberResourceACL: patch<
    any,
    UpdateTeamMemberResourceACLReq
  >`/team/member/resource_acl`,
  deleteTeamMemberResourceQuotas: del<
    any,
    DeleteTeamMemberResourceQuotasReq
  >`/team/member/resource_quotas`,

  // Team Token Switching
  getTeamToken: post<{ token: string }, { privilege_type: number; source_id: number }>`/auth/grant`,
  getPlatformToken: post<
    { token: string },
    { privilege_type: number; sdk_token_scope?: number }
  >`/auth/grant`,

  // Team Member Management
  getTeamMemberList: get<GetTeamMemberListRes, GetTeamMemberListReq>`/team/members`,
  getTeamMemberInstances: get<
    GetTeamMemberInstancesRes,
    GetTeamMemberInstancesReq
  >`/team/member/instances`,
  deleteTeamMemberInstance: del<any, DeleteTeamMemberInstanceReq>`/team/member/instance`,

  // Team Member Binding
  bindTeamMember: post<any, BindTeamMemberReq>`/team/binding`,
  unbindTeamMember: (data: UnbindTeamMemberReq, config: RequestConf = {}) =>
    http.delete<any>('/team/binding', { ...config, data }),

  // Team Snapshots
  getTeamSharedSnapshots: get<
    GetTeamSharedSnapshotsRes,
    GetTeamSharedSnapshotsReq
  >`/team/snapshots`,
  getTeamMemberSnapshots: get<
    GetTeamMemberSnapshotsRes,
    GetTeamMemberSnapshotsReq
  >`/team/member/snapshots`,
  importTeamSnapshot: post<any, ImportTeamSnapshotReq>`/team/snapshot`,
  removeTeamSharedSnapshot: (data: RemoveTeamSharedSnapshotReq, config: RequestConf = {}) =>
    http.delete<any>('/team/snapshot', { ...config, data }),
  removeTeamMemberSnapshot: (data: RemoveTeamMemberSnapshotReq, config: RequestConf = {}) =>
    http.delete<any>('/team/member/snapshot', { ...config, data }),

  // Team Billing
  getTeamMemberBills: get<
    GetTeamMemberBillsRes,
    {
      res_id: string
      member_res_ids?: string[]
      page?: number
      per_page?: number
      catalog?: number
    }
  >`/team/member/bills`,

  // Team Storage Space
  getTeamMemberVolumeStats: get<
    GetTeamMemberVolumeStatsRes,
    GetTeamMemberVolumeStatsReq
  >`/team/member/volume_stats`,
  getMemberVolumes: get<GetMemberVolumesRes, { res_id: string }>`/team/member/volumes`,

  // Team Shared SubVolume Management (team token required)
  createTeamSubvolume: post<
    any,
    { type: number; domain: number; init_quota_gb: number }
  >`/team/subvolume`,
  modifyTeamSubvolume: patch<any, { res_id: string; quota_gb: number }>`/team/subvolume`,
  //team member
  getTeamMember: get<GetTeamMemberRes, GetTeamMemberReq>`/team/member`,
  createTeamMember: post<CreateTeamMemberRes, CreateTeamMemberReq>`/team/member`,
  updateTeamMemberNickName: patch<any, UpdateTeamMemberNickNameReq>`/team/member/nickname`,
  updateTeamMemberNote: patch<any, UpdateTeamMemberNoteReq>`/team/member/note`,
  updateTeamMemberRole: patch<any, UpdateTeamMemberRoleReq>`/team/member/role`,
  updateTeamMemberPassword: patch<
    UpdateTeamMemberPasswordRes,
    UpdateTeamMemberPasswordReq
  >`/team/member/password`,
  frozenTeamMember: patch<any, FrozenTeamMemberReq>`/team/member/frozen`,
  unFrozenTeamMember: patch<any, UnFrozenTeamMemberReq>`/team/member/unfrozen`,
  removeTeamMember: del<any, RemoveTeamMemberReq>`/team/member`,
  reClasimMemberCredits: del<any, ReMemberClaimCreditsReq>`/team/member/credits`,

  //distribute credit
  distributeCredit: post<DistributeCreditRes, DistributeCreditReq>`/team/member/credits`,

  // Transfer credits from platform to team (requires platform token via privilege_type: 58)
  transferCreditsToTeam: post<
    TransferCreditsToTeamRes,
    TransferCreditsToTeamReq
  >`/team/credits_transfer`,

  // Asset Domain credits transfer (docs/ASSET_DOMAIN_FRONTEND.md)
  getAssetDomains: get<ListAssetDomainsRes>`/asset_domain/list`,
  createAssetTransfer: post<CreateAssetTransferRes, CreateAssetTransferReq>`/asset_transfer/credit`,
  getAssetTransfers: get<ListAssetTransfersRes, ListAssetTransfersReq>`/asset_transfer/list`,

  // Team Statistics (requires team scope token)
  getTeamStatOverview: get<GetTeamStatOverviewRes, GetTeamStatReq>`/team/stat/overview`,
  getTeamStatInstances: get<GetTeamStatInstancesRes, GetTeamStatReq>`/team/stat/instances`,
  getTeamStatFSSpaces: get<GetTeamStatFSSpacesRes, GetTeamStatReq>`/team/stat/fs_spaces`,
  getTeamStatSharedSnapshots: get<
    GetTeamStatSharedSnapshotsRes,
    GetTeamStatReq
  >`/team/stat/shared_snapshots`,
  getTeamStatSnapshots: get<GetTeamStatSnapshotsRes, GetTeamStatReq>`/team/stat/snapshots`,
  getTeamStatStorages: get<GetTeamStatStoragesRes, GetTeamStatReq>`/team/stat/storages`,
  getTeamStatMembers: get<GetTeamStatMembersRes, GetTeamStatReq>`/team/stat/members`,
  getTeamStatPersonalInstances: get<
    GetTeamStatPersonalInstancesRes,
    GetTeamStatReq
  >`/team/stat/personal_instances`,
  getTeamStatMemberInstances: get<
    GetTeamStatMemberInstancesRes,
    GetTeamStatMemberInstancesReq
  >`/team/stat/member_instances`,
  getTeamStatMemberSnapshots: get<
    GetTeamStatMemberSnapshotsRes,
    GetTeamStatMemberSnapshotsReq
  >`/team/stat/member_snapshots`,
  getTeamStatMemberFSSpaces: get<
    GetTeamStatMemberFSSpacesRes,
    GetTeamStatMemberFSSpacesReq
  >`/team/stat/member_fs_spaces`,

  // Credential (AK/SK)
  createCredential: post<CreateCredentialRes, CreateCredentialReq>`/credential`,
  getCredential: get<GetCredentialRes, GetCredentialReq>`/credential`,
  getCredentialList: get<GetCredentialListRes, GetCredentialListReq>`/credential/list`,
  updateCredential: put<any, UpdateCredentialReq>`/credential`,
  deleteCredential: del<any, DeleteCredentialReq>`/credential`,
  rotateCredential: post<RotateCredentialRes, RotateCredentialReq>`/credential/rotate`,
  bindCredentialResource: post<any, CredentialBindResourceReq>`/credential/bind_resource`,
  unbindCredentialResource: (data: CredentialUnbindResourceReq, config: RequestConf = {}) =>
    http.delete<any>('/credential/unbind_resource', { ...config, data }),
}
